













































import { Component, Vue, Ref } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { LoginValidationErrors } from '../store/modules/auth/types';
import { LoginData } from '../models/login';

@Component({
  name: 'ForgotPassword',
})
export default class ForgotPassword extends Vue {
  @Ref() readonly forgotPasswordForm!: HTMLFormElement;

  @Action('auth/recoverPassword') recover!: () => Promise<any>;
  @Action('auth/setLoginData') setLoginData!: (loginData: LoginData) => void;
  @Getter('auth/getLoginData') getLoginData!: () => LoginData;
  @Getter('auth/getLoginErrors') errors!: () => LoginValidationErrors;

  errorMessage = '';
  formValidity = false;
  submiting = false;
  success = false;

  recoverPassword() {
    if (!this.formValidity) {
      this.forgotPasswordForm.validate();
      return;
    }

    this.submiting = true;

    this.recover()
      .then(() => {
        this.submiting = false;
        this.success = true;
      })
      .catch(() => {
        this.submiting = false;
        this.errorMessage = 'Bad request. The email is not valid.';
      });
  }
}
